import React from "react";
import "./Calendar.css";

export default () => {
    return (
        <ul id="bookingColors">
            <li className="colorIndicator redDot">
                <span>Kursus</span>
            </li>
            <li className="colorIndicator yellowDot">
                <span>Booking oprettet</span>
            </li>
            <li className="colorIndicator greenDot">
                <span>Journal gennemført</span>
            </li>
            <li className="colorIndicator blueDot">
                <span>Faktureret</span>
            </li>
            <li className="colorIndicator fullRedDot">
                <span>Ikke tilgængelig</span>
            </li>
            <li className="colorIndicator fullWhiteDot">
                <span>Åbninger</span>
            </li>
            <li className="colorIndicator fullGrayDot">
                <span>Standard</span>
            </li>
        </ul>
    );
};
